import { render } from "./App.vue?vue&type=template&id=af9ce682&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=af9ce682&lang=less"

import exportComponent from "/Users/fyh/Desktop/Luckytu-Project/Luckytu_Interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__